import InputContainer from './InputContainer';
import { useEffect, useRef } from 'react';

const TextArea = ({
    value,
    onChange,
    label,
    placeholder,
    autoFocus,
    className,
    inputClassName,
    onBlur,
    disabled,
    id,
}) => {
    const inputRef = useRef();

    useEffect(() => {
        if (autoFocus) {
            setTimeout(() => {
                inputRef.current?.focus();
            }, 100);
        }
    }, [autoFocus]);

    return (
        <InputContainer label={label} className={className} id={id}>
            <textarea
                ref={inputRef}
                value={value}
                placeholder={placeholder}
                onChange={e => onChange && onChange(e.target.value)}
                className={`w-full h-30 ${inputClassName}`}
                autoFocus={autoFocus}
                onBlur={onBlur}
                disabled={disabled}
            />
        </InputContainer>
    );
};

export default TextArea;
